document.addEventListener('DOMContentLoaded', () => {
  const selector = document.querySelector('[data-sns-selector]');
  if (selector) {
    selector.addEventListener('submit', (event) => {
      event.preventDefault();
      const data = new FormData(selector);
      const answers = [...data.entries()].filter(([, value]) => String(value).trim());
      const summary = selector.querySelector('[data-sns-selector-result]');
      if (!summary) return;
      summary.hidden = false;
      if (answers.length < 5) {
        summary.innerHTML = '<strong>A few more details will make this useful.</strong><p>Please answer at least five questions, or use the human-help link below.</p>';
        return;
      }
      const material = data.get('project') === 'decorative' ? 'PLA and specialty PLA' : data.get('outdoor') === 'yes' ? 'materials with verified outdoor specifications' : 'PLA or PETG with verified project specifications';
      summary.innerHTML = `<strong>Your starting point: ${material}.</strong><p>This is guidance, not a print-success guarantee. Compare the verified product description with your printer manual, and only choose an item marked available.</p><p><a href="/collections/available-now">See available products</a> or <a href="/pages/contact">ask Sparks &amp; Spools for help</a>.</p>`;
    });
  }

  document.querySelectorAll('.sns-local-nav details').forEach((details) => {
    details.addEventListener('toggle', () => {
      if (!details.open) return;
      document.querySelectorAll('.sns-local-nav details[open]').forEach((other) => {
        if (other !== details) other.removeAttribute('open');
      });
    });
  });

  const soldOutToggle = document.querySelector('[data-sns-show-sold-out]');
  if (soldOutToggle) {
    const storageKey = 'sns-show-sold-out';
    try {
      soldOutToggle.checked = window.sessionStorage.getItem(storageKey) === 'true';
    } catch (_error) {
      // Storage can be unavailable in private browsing; the control still works for this page.
    }
    const updateSoldOut = () => {
      document.querySelectorAll('product-card[data-sns-availability="sold-out"]').forEach((card) => {
        const gridItem = card.closest('li') || card;
        gridItem.hidden = !soldOutToggle.checked;
      });
    };
    soldOutToggle.addEventListener('change', () => {
      try {
        window.sessionStorage.setItem(storageKey, String(soldOutToggle.checked));
      } catch (_error) {
        // Keep the page-level behavior even when storage is unavailable.
      }
      updateSoldOut();
    });
    updateSoldOut();
  }
});
